/* Pawganix ADA 009 (WCAG 2.2.2 Pause, Stop, Hide): pause control for looping videos.
   Puts a small Pause / Play button next to every <video loop> that has no native controls,
   including videos the page builds after load. Videos that already have controls are left alone.
   A video that carries its own pause button opts out with data-pgx-own-toggle, so it never
   gets a second one (the CalmGuard PDP video sections, 2026-10-22).
   Pausing also blocks other scripts (lazy loaders, scroll players) from restarting that video.
   Visitors who ask their device for reduced motion get every looping video paused on load,
   with Play available. The choice is not remembered between pages. */
(function () {
  'use strict';
  if (window.pgxVidPauseInit) return;
  window.pgxVidPauseInit = true;

  var SIZE = 36, GAP = 10;
  var reduce = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  var nativePlay = HTMLMediaElement.prototype.play;
  var list = [];
  var queued = false;
  var ro = window.ResizeObserver ? new ResizeObserver(queue) : null;
  var attrMO = new MutationObserver(function () { queue(); setTimeout(queue, 450); });

  var st = document.createElement('style');
  st.textContent =
    'button.pgx-vid-toggle{position:absolute;z-index:6;box-sizing:border-box;width:36px;height:36px;min-width:0;min-height:0;margin:0;padding:0;display:flex;align-items:center;justify-content:center;background:rgba(0,0,0,.65);color:#fff;border:2px solid #fff;border-radius:50%;cursor:pointer;line-height:0}' +
    'button.pgx-vid-toggle[hidden]{display:none}' +
    'button.pgx-vid-toggle:hover{background:rgba(0,0,0,.85)}' +
    'button.pgx-vid-toggle svg{width:14px;height:14px;fill:currentColor;display:block}' +
    'button.pgx-vid-toggle .pgx-vid-play{display:none}' +
    'button.pgx-vid-toggle[data-state="paused"] .pgx-vid-play{display:block}' +
    'button.pgx-vid-toggle[data-state="paused"] .pgx-vid-bars{display:none}';
  document.head.appendChild(st);

  var ICONS =
    '<svg class="pgx-vid-bars" viewBox="0 0 14 14" aria-hidden="true" focusable="false"><rect x="2" y="1" width="3.5" height="12"/><rect x="8.5" y="1" width="3.5" height="12"/></svg>' +
    '<svg class="pgx-vid-play" viewBox="0 0 14 14" aria-hidden="true" focusable="false"><path d="M3 1l10 6-10 6z"/></svg>';

  function sync(v) {
    var s = v.__pgx;
    s.btn.setAttribute('data-state', s.held ? 'paused' : 'playing');
    s.btn.setAttribute('aria-label', s.held ? 'Play video' : 'Pause video');
  }

  /* The button is a sibling placed over the video's bottom right corner. Offsets are read
     from the video itself, so no parent element needs restyling. */
  function place(v) {
    var s = v.__pgx, b = s.btn;
    if (b.parentNode !== v.parentNode) {
      if (!v.parentNode) return;
      v.parentNode.insertBefore(b, v.nextSibling);
    }
    var ok = !v.controls && v.offsetWidth > 0 && v.offsetHeight > 0;
    if (ok) {
      var cs = window.getComputedStyle(v);
      ok = cs.visibility !== 'hidden' && parseFloat(cs.opacity) > 0.02;
    }
    if (b.hidden !== !ok) b.hidden = !ok;
    if (!ok) return;
    var left = Math.max(v.offsetLeft, v.offsetLeft + v.offsetWidth - SIZE - GAP);
    var top = Math.max(v.offsetTop, v.offsetTop + v.offsetHeight - SIZE - GAP);
    if (s.l !== left) { b.style.left = left + 'px'; s.l = left; }
    if (s.t !== top) { b.style.top = top + 'px'; s.t = top; }
  }

  function updateAll() {
    var keep = [];
    for (var i = 0; i < list.length; i++) {
      var v = list[i];
      if (!v.isConnected) {
        var b = v.__pgx.btn;
        if (b.parentNode) b.parentNode.removeChild(b);
        continue;
      }
      place(v);
      keep.push(v);
    }
    list = keep;
  }

  function register(v) {
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'pgx-vid-toggle';
    btn.innerHTML = ICONS;
    var s = v.__pgx = { btn: btn, held: false, l: null, t: null };
    list.push(v);

    /* While paused by the visitor, ignore play() calls from other scripts. */
    v.play = function () {
      if (s.held) return Promise.resolve();
      return nativePlay.apply(v, arguments);
    };
    /* Catches the browser's own autoplay after a lazy loader sets the source. */
    v.addEventListener('play', function () {
      if (s.held) { try { v.pause(); } catch (e) {} }
    });

    btn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      if (s.held) {
        s.held = false;
        try { var p = nativePlay.call(v); if (p && p.catch) p.catch(function () {}); } catch (e1) {}
      } else {
        s.held = true;
        try { v.pause(); } catch (e2) {}
      }
      sync(v);
    });

    if (reduce) {
      v.removeAttribute('autoplay');
      s.held = true;
      try { v.pause(); } catch (e3) {}
    }
    sync(v);

    attrMO.observe(v, { attributes: true, attributeFilter: ['class', 'style', 'hidden', 'controls'] });
    if (ro) {
      ro.observe(v);
      if (v.parentElement) ro.observe(v.parentElement);
    }
  }

  function scan() {
    queued = false;
    var vids = document.querySelectorAll('video');
    for (var i = 0; i < vids.length; i++) {
      var v = vids[i];
      if (!v.__pgx && v.loop && !v.controls && !v.hasAttribute('data-pgx-own-toggle')) register(v);
    }
    updateAll();
  }

  function queue() {
    if (queued) return;
    queued = true;
    if (window.requestAnimationFrame) window.requestAnimationFrame(scan);
    else setTimeout(scan, 50);
  }

  /* Pick up videos the page adds later, such as tiles built by a script. */
  new MutationObserver(function (muts) {
    for (var i = 0; i < muts.length; i++) {
      var added = muts[i].addedNodes;
      for (var j = 0; j < added.length; j++) {
        var n = added[j];
        if (n.nodeType === 1 && (n.nodeName === 'VIDEO' || (n.querySelector && n.querySelector('video')))) {
          queue();
          return;
        }
      }
    }
  }).observe(document.documentElement, { childList: true, subtree: true });

  window.addEventListener('resize', queue);
  window.addEventListener('load', queue);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(queue);
  /* Safety net for carousels and layout shifts that no observer reports. */
  setInterval(function () { if (!document.hidden) updateAll(); }, 1500);
  queue();
})();